import { ClarityListInterface } from '../interfaces/ClarityListInterface';
import { OnInit } from '@angular/core';
import { ListGeneric } from './list-generic';

export class ClarityListGeneric extends ListGeneric implements ClarityListInterface, OnInit {

}
